<template>
  <div class="w-full max-w-lg lg:max-w-xl mx-auto" :class="{ 'text-center': center }">
    <main class="text-grey-dark bg-white border-2 border-transparent dark:text-white dark:bg-black dark:bg-gradient-to-b dark:from-grey-darkest dark:to-black dark:border-grey-dark w-full max-w-4xl p-6 md:p-8 lg:px-10 shadow-md rounded">
      <h2
        v-if="heading"
        v-html="heading"
        class="text-black dark:text-white text-center text-2xl font-semibold"
        :class="{
          'mb-2': subheading,
          'mb-4': !subheading,
        }"></h2>
      <p
        v-if="subheading"
        v-html="subheading"
        class="text-md mb-4"
        :class="{
          'text-center': centerSubheading,
          'text-left': !centerSubheading,
        }"
      ></p>
      <slot name="main"></slot>
    </main>
    <footer class="mt-6 flex flex-col">
      <slot name="footer"></slot>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'LayoutRegistration',
  props: {
    center: {
      type: Boolean,
      default: true,
    },
    heading: {
      type: String,
    },
    subheading: {
      type: String,
    },
    centerSubheading: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
